import { forwardRef, useImperativeHandle } from "react";

import { useDisclosure } from "hooks";

import { ShipmentProgress } from "./ShipmentProgress";
import { ShipmentProgressDetail } from "./ShipmentProgressDetail";

interface Props {
  shipment: ShipperCondensedShipment | undefined;
  // Fetched by the page with useShipmentProgress, so the Quotes section can
  // share the same counts.
  shipmentProgress: ShipmentProgress | null;
  error: string | null;
}

export interface ShipmentProgressRef {
  openProgressDetail: () => void;
}

export const ShipmentProgressContainer = forwardRef<ShipmentProgressRef, Props>(
  (props, ref) => {
    const { shipment, shipmentProgress, error } = props;
    const { isOpen, onClose, onOpen } = useDisclosure();

    useImperativeHandle(ref, () => ({
      openProgressDetail: onOpen,
    }));

    return (
      <ShipmentProgress
        shipmentProgress={shipmentProgress}
        shipment={shipment}
        error={error}
        shipmentProgressDetail={
          <ShipmentProgressDetail
            shipment={shipment}
            progress={shipmentProgress}
            open={isOpen}
            onClose={onClose}
          />
        }
      />
    );
  },
);
